import type { CompanyDto } from '@bqcrm/shared';
import { Badge } from '@mantine/core';

/** Znacznik firmy (kolor + skrót) — używany wszędzie, gdzie dane należą do jednego podmiotu. Rozmiar jak TradeBadge (sm). */
export function CompanyBadge({ company, full, size = 'sm' }: { company: Pick<CompanyDto, 'code' | 'shortName' | 'color'>; full?: boolean; size?: 'xs' | 'sm' | 'md' }) {
  return (
    <Badge variant="light" style={{ backgroundColor: `${company.color}1f`, color: company.color }} radius="sm" size={size}>
      {full ? `${company.code} · ${company.shortName}` : company.code}
    </Badge>
  );
}
